import { selectProfile } from '@modules/auth/auth.Dux'
import React from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { DashboardHeader } from '../Admin.Header'

const AdminWelcome = ({ user = {} }) => (
  <>
    <DashboardHeader title="Admin" />
    <div style={{ padding: '32px' }}>
      <h1>
        <Trans>Hola de nuevo</Trans> {user.name}{' '}
      </h1>
      <p>
        <Trans>Este es el panel de administración de MeetingDoctors</Trans>
      </p>
    </div>
  </>
)

const mapStateToProps = (state) => ({
  user: selectProfile(state),
})

export default compose(withTranslation(), connect(mapStateToProps))(AdminWelcome)
